// extracted by mini-css-extract-plugin
export default {"loadingCover":"LoadingCover__loadingCover--c8NoJ97","loadingText":"LoadingCover__loadingText--kWtZ5IJ","loadingCoverWithoutText":"LoadingCover__loadingCoverWithoutText--kHPWs71"};